<template>
  <v-col cols="12" class="mt-6">
    <v-card flat outlined>
      <v-card-title>
        <span class="text-h6 font-weight-medium">{{ title }}</span>
      </v-card-title>

      <v-card-text outlined>
        <v-data-table
          hide-default-footer
          :headers="headers"
          :items="items.data"
        ></v-data-table>

        <v-pagination
          v-model="pageModel"
          :length="items.last_page"
          @input="handlePagination"
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "GroupedDataTable",
  props: {
    title: String,
    headers: Array,
    items: Object,
    page: Number,
    sectionKey: String,
  },
  computed: {
    pageModel: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
  },
  methods: {
    handlePagination(val) {
      this.$emit("page-change", val, this.sectionKey);
    },
  },
};
</script>
